import {
    RESET_REFERENCE_DATA,
    SZ_BANK_REFERENCE_DATA_SET_VALUE,
    SZ_BRANCH_CODES_REFERENCE_DATA_API_STATUS,
    SZ_BRANCH_CODES_REFERENCE_DATA_SET_VALUE,
    SZ_SET_REF_NUMBER,
} from '../../actions/sizotsaFuneralClaim/referenceData';

export const initReferenceData = {
    apiStatus: null,
    applicationData: {
        bankData: null,
        branchCodesData: null,
    },
    buyRef: null,
};

export default (state = initReferenceData, action) => {
    switch (action.type) {
        case SZ_BRANCH_CODES_REFERENCE_DATA_API_STATUS:
            return { ...state, apiStatus: action.value };

        case SZ_BANK_REFERENCE_DATA_SET_VALUE:
            return { ...state, applicationData: { ...state.applicationData, bankData: action.value } };

        case SZ_BRANCH_CODES_REFERENCE_DATA_SET_VALUE:
            return {
                ...state,
                applicationData: {
                    ...state.applicationData,
                    branchCodesData: action.value,
                },
            };
        case SZ_SET_REF_NUMBER:
            return {
                ...state,
                buyRef: action?.value,
            };
        case RESET_REFERENCE_DATA:
            return { ...initReferenceData };
        default:
            return state;
    }
};
